export enum Currencies {
  EGP = 'EGP',
  USD = 'USD'
}



